<template>
  <div class="page">
    <div class="swiper">
      <el-carousel height="500px" :autoplay="true">
        <el-carousel-item v-for="item in slideshow" :key="item">
          <img :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="plate-one">
      <div class="flex1">
        <div class="plate-one-left">
          <div class="plate-one-left-title">
            <img src="@/assets/home/01.png" alt="">
          </div>
          <div class="plate-one-left-img">
            <img :src="config.companyProfileUrl" alt="">
          </div>
        </div>
        <div class="plate-one-right">
          <router-link to="/desc" class="a">
            <p>{{config.companyProfileText}}</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="plate-two">
      <div class="flex2">
        <div class="more">更多+</div>
        <div class="plate-two-title">
          <img src="@/assets/home/04.png" alt="">
        </div>
        <div class="more">
          <router-link to="/news">更多+</router-link>
        </div>
      </div>
      <template v-for="(item, index) in pressnews">
        <div class="plate-two-top" v-if="index%2!==0" :key="index">
          <div class="plate-two-top-left">
            <img :src="item.journalismUrl" alt="">
          </div>
          <div class="plate-two-top-right">
            <div class="title">
              <div class="title-box">
                <router-link class="a" :to="`/news-info?id=${item.id}`">
                  {{item.journalismTitle}}
                </router-link>
              </div>
              <div class="title-date">
                <div class="title-date-top">{{(handleTime(item.releaseTime) || '').split(',')[1]}}</div>
                <div class="title-date-bottom">{{(handleTime(item.releaseTime) || '').split(',')[0]}}</div>
              </div>
            </div>
          </div>
          <div class="mask"></div>
        </div>
        <div class="plate-two-bottom" :key="index" v-else>
          <div class="plate-two-bottom-left">
            <div class="title">
              <div class="title-box">
                <router-link class="a" :to="`/news-info?id=${item.id}`">
                  {{item.journalismTitle}}
                </router-link>
              </div>
              <div class="title-date">
                <div class="title-date-top">{{(handleTime(item.releaseTime) || '').split(',')[1]}}</div>
                <div class="title-date-bottom">{{(handleTime(item.releaseTime) || '').split(',')[0]}}</div>
              </div>
            </div>
          </div>
          <div class="plate-two-bottom-right">
            <img :src="item.journalismUrl" alt="">
          </div>
          <div class="mask"></div>
        </div>
      </template>
    </div>
    <div class="plate-three">
      <!-- <div class="plate-three-title">
        <img src="@/assets/home/09.png" alt="">
      </div> -->
      <div class="flex2">
        <div class="more">更多+</div>
        <div class="plate-three-title">
          <img src="@/assets/home/09.png" alt="">
        </div>
        <div class="more">
          <router-link to="/project">更多+</router-link>
        </div>
      </div>
      <div class="plate-three-list">
        <div class="item" v-for="i in projectList" :key="i.d">
          <van-image width="100%" height="418" fit="cover" :src="i.projectHomePageUrl" />
          <!-- <img src="@/assets/home/10.png" alt=""> -->
          <div class="item-content">
            <div class="item-content-title">
              <span><Strong>{{i.projectName}}</Strong></span>
              <!-- <span>factory  building</span> -->
            </div>
          </div>
          <div class="item-content">
            <div class="item-content-title">
              <span><Strong>{{i.projectName}}</Strong></span>
            </div>
            <div class="item-content-txt">
              <p>{{i.projectBriefIntroduction}}</p>
            </div>
            <div class="item-content-btn">
              <router-link class="a" :to="`/project-info?id=${i.id}`">
                <span>查看详情</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="item" v-if="projectList.length<2">
        </div>
        <div class="item" v-if="projectList.length<3">
        </div>
      </div>
    </div>
    <div class="plate-four">
      <div class="plate-four-title">
        <img src="@/assets/home/11.png" alt="">
      </div>
      <div class="top">
        <div class="top-left">
          <router-link to="/charitable" class="a">
            <p>{{foundation.foundationPurpose}}</p>
          </router-link>
        </div>
        <div class="top-right">
          <img :src="foundation.masterDrawing" alt=""></div>
      </div>
      <div class="bottom">
        <div class="bottom-left">
          <XSwiper :slideList="(foundation.honorUrl || '').split(',')"></XSwiper>
        </div>
        <div class="bottom-right">
          <div class="item" v-for="(t, i) in incidentAll" :key="i">
            <div class="item-left">
              <p style="width: 105px;">{{t.incidentTime}}</p>
              <div class="item-spot"></div>
            </div>
            <div class="item-line">
            </div>
            <div class="item-right">
              <p>{{t.incidentExplain}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XSwiper from '@/components/swiper';
import { mapGetters, mapActions } from 'vuex';
import { projectTment } from '@/api/api';
export default {
  components: { XSwiper },
  data() {
    return {
      projectList: []
    };
  },
  created() {
    this.getProjectAllPage();
  },
  computed: {
    ...mapGetters(['config', 'pressnews', 'foundation', 'incidentAll']),
    slideshow() {
      return (this.config.slideshow || '').split(',');
    }
  },
  methods: {
    ...mapActions('data', { getPressCenter: 'getPressCenter' }),
    handleTime(time) {
      return this.$moment(time).format('YYYY-MM,DD');
    },
    getProjectAllPage() {
      projectTment().then(res => {
        this.projectList = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$page-center: 1200px;
$color1: #444;
$color2: #666;
.page {
  width: 100%;
  min-height: 100%;
  ::v-deep .swiper {
    margin: auto;
    .el-carousel__arrow {
      background-color: rgba(31, 45, 61, 0.8);
    }
    .el-carousel__item {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .flex2 {
    .more {
      font-size: 16px;
      font-weight: 700;
      display: block;
      padding-bottom: 16px;
      cursor: pointer;
    }
    .more:nth-of-type(1) {
      opacity: 0;
    }
  }
  .plate-one {
    width: $page-center;
    margin: 0 auto;
    padding: 50px 0 80px;
    &-left {
      width: 58%;
      &-title {
        width: 205px;
        margin-left: auto;
        margin-bottom: 15px;
      }
      &-img {
        height: 468px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    &-right {
      width: 40%;
      background: url(~@/assets/home/03.png) no-repeat;
      background-size: 100%;
      margin-top: 50px;
      padding: 90px 20px 0;
      box-sizing: border-box;
      font-size: 20px;
      letter-spacing: 2px;
      text-indent: 2em;
      line-height: 30px;
      text-align: justify;
      height: 515px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 14;
      -webkit-box-orient: vertical;
      color: $color1;
    }
    .more {
      text-align: right;
      padding-top: 30px;
    }
  }
  .plate-two {
    width: $page-center;
    margin: 0 auto;
    padding: 50px 0 80px;
    color: $color1;
    // line-height: 0;

    &-title {
      width: 205px;
      padding-bottom: 25px;
    }
    &-top {
      display: flex;
      height: 341px;
      position: relative;
      &-left {
        width: 53%;
        height: 100%;
        overflow: hidden;
        line-height: 0;
      }
      &-right {
        width: 47%;
        height: 100%;
        background-color: #e1e7f1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 130px 20px 0;
        box-sizing: border-box;
        .title {
          display: flex;
          max-width: 300px;
          flex-direction: column;
          justify-content: center;
          background-color: #e1e7f1;
          position: relative;
          &-box {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          &-date {
            width: 140px;
            height: 120px;
            position: absolute;
            background: url(~@/assets/home/07.png) no-repeat;
            background-size: 100% 100%;
            left: 88%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &-top {
              font-size: 35px;
              font-size: 900;
            }
            &-bottom {
              font-size: 16px;
            }
          }
        }
      }
      .mask {
        width: 150px;
        height: 100%;
        position: absolute;
        background-color: #e1e7f1;
        left: 100%;
        top: 0;
      }
    }
    &-bottom {
      display: flex;
      height: 341px;
      position: relative;
      &-left {
        width: 47%;
        background-color: #e1e7f1;
        width: 47%;
        height: 100%;
        background-color: #e1e7f1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 130px 20px 0;
        box-sizing: border-box;
        .title {
          display: flex;
          max-width: 300px;
          flex-direction: column;
          justify-content: center;
          background-color: #e1e7f1;
          position: relative;
          &-box {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          &-date {
            width: 140px;
            height: 120px;
            position: absolute;
            background: url(~@/assets/home/08.png) no-repeat;
            background-size: 100% 100%;
            right: 92%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &-top {
              font-size: 35px;
              font-size: 900;
            }
            &-bottom {
              font-size: 16px;
            }
          }
        }
      }
      &-right {
        width: 53%;
        height: 100%;
        overflow: hidden;
        line-height: 0;
      }
      .mask {
        width: 150px;
        height: 100%;
        position: absolute;
        background-color: #e1e7f1;
        right: 100%;
        top: 0;
      }
    }
  }
  .plate-three {
    width: $page-center;
    margin: 0 auto;
    padding: 50px 0 80px;
    &-title {
      width: 205px;
      padding-bottom: 25px;
      margin: 0 auto;
    }
    &-list {
      display: flex;
      flex-wrap: wrap;
      .item {
        flex: 1;
        color: #fff;
        position: relative;
        overflow: hidden;
        line-height: 0;
        &-content {
          line-height: initial;
          padding: 50px;
          padding-right: 70px;
          box-sizing: border-box;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          display: flex;
          flex-direction: column;
          &-title {
            display: flex;
            flex-direction: column;
            font-size: 20px;
            margin-bottom: 40px;
            span:nth-of-type(1) {
              font-size: 28px;
            }
          }
          &-txt {
            margin-bottom: auto;
            line-height: 25px;
            letter-spacing: 2px;
          }
          &-btn {
            padding: 8px 0;
            width: 120px;
            text-align: center;
            display: inline-block;
            background-color: #fff;
            color: #00b5ee;
            cursor: pointer;
          }
        }
        &-content:nth-last-of-type(1) {
          right: 100%;
          transition: all 300ms;
        }
      }
      .item:nth-of-type(3) {
        .item-content:nth-last-of-type(1) {
          left: 100%;
          transition: all 300ms;
        }
      }
      .item:nth-of-type(1):hover {
        .item-content:nth-of-type(1) {
          opacity: 0;
        }
        .item-content:nth-last-of-type(1) {
          right: 0;
          background-color: rgba($color: #1c3c8a, $alpha: 0.5);
        }
      }
      .item:nth-of-type(2):hover {
        .item-content:nth-of-type(1) {
          opacity: 0;
        }
        .item-content:nth-last-of-type(1) {
          right: 0;
          background-color: rgba($color: #1c3c8a, $alpha: 0.5);
        }
      }
      .item:nth-of-type(2):hover {
        .item-content:nth-of-type(1) {
          opacity: 0;
        }
        .item-content:nth-last-of-type(1) {
          right: 0;
          background-color: rgba($color: #1c3c8a, $alpha: 0.5);
        }
      }
      .item:nth-of-type(3):hover {
        .item-content:nth-of-type(1) {
          opacity: 0;
        }
        .item-content:nth-last-of-type(1) {
          left: 0;
          background-color: rgba($color: #1c3c8a, $alpha: 0.5);
        }
      }
    }
  }
  .plate-four {
    width: $page-center;
    margin: 0 auto;
    padding: 50px 0 80px;
    color: $color1;
    &-title {
      width: 205px;
      padding-bottom: 25px;
      margin: 0 auto;
    }
    .top {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      &-left {
        width: 47%;
        padding: 0 50px;
        margin: 30px 0;
        text-indent: 2em;
        // color: #1c3c8a;
        letter-spacing: 2px;
        // overflow: hidden;
        // display: -webkit-box;
        // -webkit-line-clamp: 3;
        // text-overflow: ellipsis;
        // -webkit-box-orient: vertical;
      }
      &-right {
        width: 53%;
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      height: 251px;
      &-left {
        width: 55%;
      }
      &-right {
        width: 43%;
        // color: #1c3c8a;
        letter-spacing: 2px;
        overflow-y: scroll;
        .item {
          display: flex;
          &-left {
            white-space: nowrap;
            // margin-top: 30px;
            position: relative;
          }
          &-line {
            width: 3px;
            background-color: $color2;
            margin: 0 11px;
            flex-shrink: 0;
          }
          &-spot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: $color2;
            position: absolute;
            top: 10.5px;
            right: -17.5px;
            transform: translateY(-50%);
          }
          &-right {
            margin-bottom: 30px;
          }
        }
        .item:nth-last-of-type(1) {
          .item-right {
            margin-bottom: 0;
          }
        }
      }
      // &-right::-webkit-scrollbar {
      //   display: none;
      // }
    }
  }
}
.flex1 {
  display: flex;
  justify-content: space-between;
}
.flex2 {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
</style>
